export const LEVELS = [
  'ground',
  'side_balcony_left',
  'side_balcony_right',
  'upper_balcony',
] as const;
export type Level = (typeof LEVELS)[number];

export const LEVEL_LABELS_TR: Record<Level, string> = {
  ground: 'Alt Kat',
  side_balcony_left: 'Sol Balkon',
  side_balcony_right: 'Sağ Balkon',
  upper_balcony: 'Üst Balkon',
};

export const SEAT_KINDS = ['standard', 'protocol', 'special'] as const;
export type SeatKind = (typeof SEAT_KINDS)[number];

// Derived render state — order matters (priority in resolver).
export const SEAT_STATES = ['closed', 'protocol', 'sold', 'reserved', 'held', 'available'] as const;
export type SeatState = (typeof SEAT_STATES)[number];

export const RESERVATION_STATUSES = ['reserved', 'paid', 'cancelled', 'no_show'] as const;
export type ReservationStatus = (typeof RESERVATION_STATUSES)[number];

export const RESERVATION_SOURCES = ['web', 'admin', 'phone', 'box_office'] as const;
export type ReservationSource = (typeof RESERVATION_SOURCES)[number];

export const RESERVATION_SOURCE_LABELS_TR: Record<ReservationSource, string> = {
  web: 'Web',
  admin: 'Admin',
  phone: 'Telefon',
  box_office: 'Gişe',
};

export const EVENT_STATUSES = ['draft', 'on_sale', 'closed'] as const;
export type EventStatus = (typeof EVENT_STATUSES)[number];

// Block within ground level (left / center / right around two corridors).
export const GROUND_BLOCKS = ['left', 'center', 'right'] as const;
export type GroundBlock = (typeof GROUND_BLOCKS)[number];
